import _classCallCheck from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n\tposition: absolute;\n\topacity: 0;\n\toutline: 0;\n\tuser-select: none;\n\tpointer-events: none;\n\n\n\t:checked {\n\t\t+ ", " {\n\t\t\tcolor: ", ";\n\n\t\t\t", " {\n\t\t\t\t", " {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t:focus {\n\t\t+ ", " {\n\t\t\toutline: 1px solid ", ";\n\t\t\toutline-offset: 2px;\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n\n\t/* we need a higher specificity here than :hover */\n\t&&&:disabled {\n\t\t+ ", " {\n\t\t\tcursor: not-allowed;\n\t\t\tcolor: ", ";\n\t\t\t}\n\t\t}\n\t}\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\tdisplay: grid;\n\tgrid-column-gap: ", ";\n\tgrid-template-columns: max-content auto;\n\n\t/* we need a higher specificity here than :checked or :focus */\n\t&&&:hover {\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tdisplay: block;\n\topacity: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\tposition: relative;\n\theight: ", ";\n\tdisplay: flex;\n\talign-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tposition: relative;\n\tcolor: ", ";\n\tcursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { RadioButtonBorder, RadioButtonInner } from '@volkswagen-onehub/icons-core';
import { Text, TextColor, TextTag } from '../text';
import { styled } from '../theme-provider';

var noop = function noop() {
  return undefined;
};

var StyledLabel = styled.label.withConfig({
  displayName: "StyledLabel",
  componentId: "sc-12cr2ii"
})(_templateObject(), function (props) {
  return props.theme.interaction.recipe450.default;
});
var StyledRadioWrapper = styled.span.withConfig({
  displayName: "StyledRadioWrapper",
  componentId: "sc-1n1yaaw"
})(_templateObject2(), function (props) {
  return props.theme.textAppearances.copy0200.lineHeight;
});
var StyledRadioInner = styled(RadioButtonInner).withConfig({
  displayName: "StyledRadioInner",
  componentId: "sc-1ow7h3g"
})(_templateObject3());
var StyledFocusWrapper = styled.span.withConfig({
  displayName: "StyledFocusWrapper",
  componentId: "sc-1nt8p46"
})(_templateObject4(), function (props) {
  return props.theme.size.static200;
}, function (props) {
  return props.theme.interaction.recipe450.hover;
});
var StyledInput = styled.input.withConfig({
  displayName: "StyledInput",
  componentId: "sc-grykbk"
})(_templateObject5(), StyledFocusWrapper, function (props) {
  return props.theme.interaction.recipe450.checked;
}, StyledRadioWrapper, StyledRadioInner, StyledFocusWrapper, function (props) {
  return props.theme.interaction.recipe100.active;
}, function (props) {
  return props.theme.interaction.recipe450.active;
}, StyledFocusWrapper, function (props) {
  return props.theme.interaction.recipe450.disabled;
});
export var RadioButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioButton, _React$Component);

  function RadioButton() {
    var _this;

    _classCallCheck(this, RadioButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RadioButton).apply(this, arguments));

    _this.handleChange = function (e) {
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === void 0 ? noop : _this$props$onChange;
      onChange(e, _this.props);
    };

    _this.handleBlur = function (e) {
      var _this$props$onBlur = _this.props.onBlur,
          onBlur = _this$props$onBlur === void 0 ? noop : _this$props$onBlur;
      onBlur(e, _this.props);
    };

    _this.handleFocus = function (e) {
      var _this$props$onFocus = _this.props.onFocus,
          onFocus = _this$props$onFocus === void 0 ? noop : _this$props$onFocus;
      onFocus(e, _this.props);
    };

    _this.handleClick = function (e) {
      var _this$props$onClick = _this.props.onClick,
          onClick = _this$props$onClick === void 0 ? noop : _this$props$onClick;
      onClick(e, _this.props);
    };

    return _this;
  }

  _createClass(RadioButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          id = _this$props.id,
          name = _this$props.name,
          value = _this$props.value,
          _this$props$label = _this$props.label,
          label = _this$props$label === void 0 ? '' : _this$props$label;
      return React.createElement(StyledLabel, null, React.createElement(StyledInput, {
        checked: checked,
        disabled: disabled,
        id: id,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        type: "radio",
        value: value
      }), React.createElement(StyledFocusWrapper, null, React.createElement(StyledRadioWrapper, null, React.createElement(RadioButtonBorder, {
        variant: "default"
      }), React.createElement(StyledRadioInner, {
        variant: "default"
      })), React.createElement("span", null, label && (typeof label === 'string' ? React.createElement(Text, {
        tag: TextTag.span,
        color: TextColor.inherit
      }, label) : label))));
    }
  }]);

  return RadioButton;
}(React.Component);